import { monthsExtended } from "../../utils";

export const monthList = Array.from(Array(12))
  .map((_, i) => ({
    month: i + 1,
    monthName: monthsExtended[i],
    valorRendimento: 0,
    impostoPagoExterior: 0,
  }))
  .reverse();

export const CalcAutonomosDarfItem = {
  header: true,
  sidebar: true,
  component: "Rendimentos",
  path: "/velotax/autonomos-darf",
  name: "Calculadora",
  title: "",
  features: [
    {
      apiUrl: "/transaction",
    },
    {
      apiUrl: "/darf",
      buttonLabel: "Emitir DARF",
    },
    {
      apiUrl: "/darf/year",
    },
  ],
}